/** Color estable por texto (nombre/teléfono) para el avatar, estilo Vocero. */
const PALETA = [
  '#d97706', '#be185d', '#c2410c', '#0d9488', '#7c3aed',
  '#2563eb', '#db2777', '#059669', '#dc2626', '#4f46e5',
]

export function colorAvatar(semilla: string): string {
  let h = 0
  for (let i = 0; i < semilla.length; i++) h = (h * 31 + semilla.charCodeAt(i)) | 0
  return PALETA[Math.abs(h) % PALETA.length]
}

/** Iniciales para el avatar: dos letras del nombre, o del teléfono. */
export function iniciales(texto: string): string {
  const limpio = texto.trim()
  if (!limpio) return '··'
  const palabras = limpio.split(/\s+/).filter(Boolean)
  if (palabras.length >= 2) return (palabras[0][0] + palabras[1][0]).toUpperCase()
  // Un solo token: si es número, los dos últimos dígitos; si no, dos primeras letras.
  const soloDigitos = limpio.replace(/\D/g, '')
  if (soloDigitos.length >= 2 && soloDigitos.length === limpio.replace(/[^\d+]/g, '').length)
    return soloDigitos.slice(-2)
  return limpio.slice(0, 2).toUpperCase()
}
